var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMembericon = function SvgMembericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2834",
    fillRule: "nonzero",
    d: "M33.754 16.707c-8.342-1.565-14.902-8.12-16.46-16.46-.06-.33-.528-.33-.587 0-1.56 8.34-8.12 14.895-16.46 16.46-.33.059-.33.527 0 .586 8.34 1.565 14.9 8.12 16.46 16.46.059.33.527.33.586 0 1.56-8.34 8.12-14.895 16.46-16.46.33-.059.33-.527 0-.586m-24.082.334a7.4 7.4 0 0 1-2.813-.352h.175c4.749-1.407 8.266-5.451 9.614-9.672V6.84c.293.762.47 1.583.47 2.52-.118 3.577-3.518 7.446-7.446 7.68"
  })));
};
export default SvgMembericon;